require('typeface-montserrat')
import './assets/stylesheets/layout.css'
import './assets/stylesheets/animations.css'
import './assets/stylesheets/functions.css'
import './assets/stylesheets/variables.css'
import './styles.css'
import './assets/stylesheets/identity.css'
import './assets/stylesheets/lighter-youtube.css'
import './assets/javascripts/lighter-youtube.js'


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 0
// module chunks = 0